import { BaseLayouts } from '@/components/apppad/layouts'
/**
 * pad路由 所有路由必须以/pad开头
 * @type {[null,null]}
 */
export default [
  {
    path: '/pad',
    // name: 'work',
    component: BaseLayouts,
    meta: { title: '工作站页' },
    redirect: '/pad/index',
    children: [
      {
        path: '/pad/index',
        // component: () => import(/* webpackChunkName: "user" */ '@/views/apppad/Index')
        // component: () => import(/* webpackChunkName: "user" */ '@/views/apppad/index/ProjectIndex')
        component: () => import(/* webpackChunkName: "user" */ '@/views/apppad/index/DataIndex')
      },
      // {
      //   path: '/pad/proposalConfig',
      //   component: () => import(/* webpackChunkName: "user" */ '@/views/apppad/index/DataIndex')
      // },
      {
        path: '/pad/patient',
        meta: {
          keepAlive: true // 需要被缓存
        },
        component: () => import(/* webpackChunkName: "user" */ '@/views/apppad/patient/Index')
      },
      {
        path: '/pad/question',
        component: () => import(/* webpackChunkName: "user" */ '@/views/apppad/question/Index')
      },
      {
        path: '/pad/question/checkForm/:id',
        component: () => import(/* webpackChunkName: "user" */ '@/views/apppad/question/CheckForm')
      },
      {
        path: '/pad/patient/registerview/:id',
        component: () => import(/* webpackChunkName: "user" */ '@/views/project/patient/RegisterViewPad')
      },
      {
        path: '/pad/patient/registerform/:id',
        component: () => import(/* webpackChunkName: "user" */ '@/views/project/patient/RegisterFormPad')
      },
      {
        path: '/pad/periodForm',
        component: () => import(/* webpackChunkName: "user" */ '@/views/apppad/periodform/Index')
      },

      {
        path: '/pad/projectTemplate',
        component: () => import(/* webpackChunkName: "user" */ '@/views/apppad/projectTemplate/Index')
      },
      {
        path: '/pad/projectStartedSuccessfully',
        component: () => import(/* webpackChunkName: "user" */ '@/views/apppad/projectTemplate/ProjectStartedSuccessfully')
      },
      // {
      //   path: '/pad/datacheck/checkform/:id',
      //   component: () => import(/* webpackChunkName: "user" */ '@/views/project/datacheck/CheckForm')
      // },
    ]
  }
]
